import AddHistoryButton from "../molecules/AddHistoryButton";
import {useEffect, useRef} from "react";
import {useSelector} from "react-redux";
import ProductList from "../molecules/ProductList";

const HistoryBody = (props) => {
  const {
    componentMount,
    subModalMount,
    closeModal,
    closeSubModal,
    // setSelectedProductTab,
    // selectedProductTab,
    renderGroupedData
  } = props;

  const designHistoryList = useSelector(state => state.designHistory.designHistoryList);
  const currentProduct = useSelector(state => state.optionWindow.currentVehicle);
  const productList = useSelector(state => state.productList.productList);

  const containerRef = useRef();

  const modalProps = { closeModal, closeSubModal, componentMount, subModalMount };


  // useEffect(() => {
  //   setSelectedProductTab(currentProduct?.id);
  // }, [currentProduct]);


  useEffect(() => {
    containerRef.current &&
    containerRef.current.addEventListener("wheel", (e) => {
      e.stopPropagation();
    }, {passive: false})
  }, []);


  return (
    <div className={"design-history-body"} ref={containerRef}>
      {/*<ProductList productList={productList} selectedProductTab={selectedProductTab} setSelectedProductTab={setSelectedProductTab} />*/}
      <div className={"design-history-inner"}>
        <AddHistoryButton {...modalProps}/>
        {
          renderGroupedData(designHistoryList, componentMount, closeModal, subModalMount, closeSubModal)
        }
      </div>
    </div>
  )
}

export default HistoryBody;
